import { useMutation } from "@tanstack/react-query";
import { Product } from "../../types";
import { updateProductService } from "../realService";

export function useUpdateProductMutation(
  id: number,
  options?: {
    onSuccess?: (data: Product) => void;
    onError?: (error: any) => void;
  }
) {
  return useMutation({
    mutationFn: (data: Partial<Product>) => updateProductService(id, data),
    ...options,
  });
}
